import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ShoppingBasketIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M14.4 1.2a1 1 0 0 1 1.4.2L19.5 7H21a2 2 0 0 1 2 2v2a2 2 0 0 1-1 1.8v.3l-1 7a3 3 0 0 1-3 2.9H6a3 3 0 0 1-3-3l-1-6.9v-.3A2 2 0 0 1 1 11V9c0-1.1.9-2 2-2h1.5l3.7-5.6a1 1 0 0 1 1.6 1.2L6.8 7h10.3l-3-4.4a1 1 0 0 1 .3-1.4ZM5 9h16v2H3V9h2Zm15 4H4l1 6.9v.1c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-.1l1-6.9Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ShoppingBasketIcon;
